export default {
    key: 'schynige-platte',
    type: 'P2P',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    isLoadingPassengerOffers: true,
    isRental: false,
    origins: [],
    destinations: [
        {
            ref: 'urn:uic:stn:8507387',
            name: 'Schynige Platte',
        },
        {
            ref: 'urn:uic:stn:8507386',
            name: 'Breitlauenen',
        },
    ],
    returnOrigins: [],
    returnDestinations: [],
    isRoundtrip: 'optional',
    canSwitchDirection: true,
    canChooseReturnDestination: false,
    isUsingReductionCards: true,
    isUsingKeyCards: false,
    hidePassengerMeasurements: false,
    isUsingPromos: true,
    isPromotionRequired: false,
    hasEPR: false,
    routeVariants: [],
    routeVariantUp: 'default-schynigeplatte',
    routeVariantDown: 'default-schynigeplatte',
    upsells: [],
    isUpsellDatesRestricted: false,
    isUsingSeasonDates: false,
    departureTimeIteration: 30,
    departureTimeDefaultMin: 420,
    stayDurationIteration: 30,
    stayDurationPopular: 180,
    stayDurationMin: 30,
    salesTimeLimit: undefined,
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: 10,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: 'urn:ts:listing:trips:a80929a3-9c71-4f09-afbe-750294dc4535',
    contentfulId: 'schynige-platte',
    steps: [],
} satisfies ProductConfigP2P;
